import React from 'react';
import cn from 'classnames';
import style from './ticker.mod.scss';
import Ticker from 'react-ticker';
import { GatsbyImage } from 'gatsby-plugin-image';
import Container from '../layout/container/container';
import Lead from '../lead/lead';

const BrandTicker = ({ heading, items }) => {
  const classes = cn(style.ticker);

  return (
    <div className={classes}>
      <div className={style.ticker__lead}>
        <Container size="md">
          <Lead
            heading={heading}
            headingColor={'dark'}
            tag={2}
            headingSize="sm"
          />
        </Container>
      </div>
      <div className={style.ticker__wrap}>
        <Ticker speed={3}>
          {({ index }) => (
            <div className={style.ticker__items}>
              {items.map((item) => (
                <div
                  className={style.ticker__image}
                  key={`ticker-item-${item.id}-${index}`}
                >
                  <GatsbyImage image={item.gatsbyImageData} alt={''} />
                </div>
              ))}
            </div>
          )}
        </Ticker>
        <div className={style.ticker__left} />
        <div className={style.ticker__right} />
      </div>
      <div className={style.ticker__grid_wrap}>
        <Container size="md">
          <div className={style.ticker__grid}>
            {items.map((item) => (
              <div
                className={style.ticker__item}
                key={`ticker-item-${item.id}`}
              >
                <GatsbyImage image={item.gatsbyImageData} alt={''} />
              </div>
            ))}
          </div>
        </Container>
      </div>
    </div>
  );
};

export default BrandTicker;
